// export let url = "e-learning-server-ruddy.vercel.app";
export let url = "https://e-learning-server-k5gt.onrender.com";
export let clientUrl = process.env.REACT_APP_CLIENT_URL || `/${window.location.hostname}`;



export const list1 = [
    {
        text: "100+ Online Courses",
        img: <i className="fa-solid fa-book-open text-white"></i>
    },
    {
        text: "Expert Instructors",
        img: <i className="fa-sharp text-white fa-solid fa-person"></i>
    },
    {
        text: "Lifetime Access",
        img: <i className="fa-regular text-white fa-keyboard"></i>
    },
    {
        text: "Money Back Guarantee",
        img: <i className="fa-sharp fa-solid fa-indian-rupee-sign text-white"></i>
    }
]
export const list2 = [
    {
        text: "Facebook",
        img: <i className="fa-brands text-white fa-facebook-f"></i>
    },
    {
        text: "Twitter",
        img: <i className=" text-white fa-brands fa-twitter"></i>


    },
    {
        text: "WhatsApp",
        img: <i className="text-white fa-brands fa-whatsapp"></i>


    },
    {
        text: "Instagram",
        img: <i className=" text-white fa-brands fa-instagram"></i>


    },

]
export const crs_list = [
    {
        topic_name: "PHP Home",
        video_link: ""
    },
    {
        topic_name: "PHP Install",
        video_link: ""
    },
    {
        topic_name: "PHP Syntax",
        video_link: ""
    },
    {
        topic_name: "PHP Comments",
        video_link: ""
    },
    {
        topic_name: "PHP Variables",
        video_link: ""
    },
    {
        topic_name: "PHP Echo/Print",
        video_link: ""
    },
    {
        topic_name: "PHP Datatype",
        video_link: ""
    },
    {
        topic_name: "PHP String",
        video_link: ""
    },
    {
        topic_name: "PHP Numbers",
        video_link: ""
    },
    {
        topic_name: "PHP Casting",
        video_link: ""
    },
    {
        topic_name: "PHP Math",
        video_link: ""
    },
    {
        topic_name: "PHP Constraint",
        video_link: ""
    },
    {
        topic_name: "PHP Magic Constraint",
        video_link: ""
    },
    {
        topic_name: "PHP Operators",
        video_link: ""
    },
    {
        topic_name: "PHP If...Else...Elseif",
        video_link: ""
    },
    {
        topic_name: "PHP Switch",
        video_link: ""
    },
    {
        topic_name: "PHP Loops",
        video_link: ""
    },
    {
        topic_name: "PHP Functions",
        video_link: ""
    },
    {
        topic_name: "PHP Arrays",
        video_link: ""
    },
    {
        topic_name: "PHP Superglobals",
        video_link: ""
    },
    {
        topic_name: "PHP RegEx",
        video_link: ""
    },
]
